import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/opportunities/$opportunityId')({
  component: () => <Outlet />,
  staticData: {
    breadcrumbLabel: 'オポチュニティ一覧',
    breadcrumbLink: '/opportunities/list',
  },
})
